export default "__VITE_ASSET__B$oK7OjP__"